import { SavingState } from '@common/Common';
import EditableValueSeriesSheet from '@common/Components/EditableValueSeriesSheet.vue';
import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import SaveButton from '@common/Components/SaveButton.vue';
import ValueSeriesTable from '@Quest/_Common/Components/ValueSeriesTable.vue';
import { ICommandBase } from '@Quest/cqrs';
import ProjectNavigation from '@Quest/Projects/Components/ProjectNavigation.vue';
import { UpdateProjectResourceSavingsCommandV1 } from '@Quest/Projects/Domain/commands-core';
import ProjectsCommands from "@Quest/Projects/Domain/commands-vue-component";
import ProjectsQueries from "@Quest/Projects/Domain/queries-vue-component";
import { ProjectPlanSeriesReadModel } from '@Quest/Projects/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';
import { Route } from 'vue-router';

@Component({ components: { PortfolioNavigation, ProjectNavigation, EditableValueSeriesSheet, ValueSeriesTable, SaveButton } })
export default class ProjectResourceSavingsPage extends mixins(ProjectsQueries, ProjectsCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }
    get projectId() { return this.$route.params.projectId; }

    rm: ProjectPlanSeriesReadModel | null = null;
    isEditing: boolean = false;
    savingState: SavingState = SavingState.Saved;
    editingComment: string | null = null;

    get stopEditingLabel() { return this.savingState === SavingState.Pending ? "Cancel editing" : "Back"; }
    get inputSeries() { return this.rm!.Series.filter(a => !a.IsTotal); }
    get isSubmitted(): boolean { return this.rm!.IsSubmitted; }
    get comment(): string | null { return this.rm.Comment; }


    startEditing()
    {
        this.editingComment = this.rm.Comment;
        this.isEditing = true;
    }

    cancelEditing() 
    {
        if (this.savingState === SavingState.Saved) 
        {
            this.isEditing = false;
        }
        else if (this.savingState === SavingState.Pending && confirm("You have unsaved changes. Are you sure you want to cancel editing?")) 
        {
            this.savingState = SavingState.Saved;
            this.isEditing = false;
        }
    }

    onDataChange()
    {
        this.savingState = SavingState.Pending;
    }

    handleSaveCommand()
    {
        if (!this.rm) return;

        const entries = (this.$refs.sheet as any).getEntriesForSave();
        this.invokeUpdateProjectResourceSavingsCommandV1(this.workspaceId, this.rm.PortfolioId, this.rm.ProjectId, this.rm.ActivePlanId, this.rm.ProjectPlanId, this.rm.Granularity, entries, this.editingComment);
        this.savingState = SavingState.InProgress;
    }

    mounted()
    {
        document.title = "Resource savings | TransparentChoice";
        const projectPlanId = this.$route.params.planId;
        this.runProjectResourceSavingsQueryV1(this.workspaceId, this.tchProjectId, this.projectId, projectPlanId);
    }


    onSetModel(model: any, modelName: string)
    {
        if (modelName == "ProjectPlanSeriesReadModel")
        {
            this.rm = model as ProjectPlanSeriesReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateProjectResourceSavingsCommandV1.matchType(cmd))
        {
            this.runProjectResourceSavingsQueryV1(this.workspaceId, this.tchProjectId, this.projectId, this.rm!.ProjectPlanId);

            if (this.savingState === SavingState.InProgress)
            {
                this.savingState = SavingState.Saved;
            }
        }
    }

    beforeRouteLeave(to: Route, from: Route, next: (arg?: any) => void) 
    {
        if (this.savingState === SavingState.Pending) 
        {
            if (confirm("You have unsaved changes. Do you want to save them before leaving?")) 
            {
                this.handleSaveCommand();
                next();
            }
            else 
            {
                next();
            }
        }
        else 
        {
            next();
        }
    }
}